import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const ListItem = ({ title, value, active, onChange, onKeyDown }) => {
	const buttonCx = cx(styles.ListItem, {
		[styles.ListItem_active]: active
	});

	return (
		<button
			type="button"
			className={buttonCx}
			data-value={value}
			onClick={onChange}
			aria-label={title}
			onKeyDown={onKeyDown}
		>
			{title}
		</button>
	);
};

ListItem.propTypes = {
	title: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	active: PropTypes.bool,
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func
};

ListItem.defaultProps = {
	onChange: _.noop,
	active: false
};

export default ListItem;
